import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SettingsService } from 'src/app/services/settings.service';
import {MetodosServicio} from 'src/app/_helpers/interfaces/metodos-servicio';
import { Entidad } from 'src/app/_models/entidad';


@Injectable()

export class EntidadService extends MetodosServicio<Entidad> {

  constructor(
    public http: HttpClient,
    private settings: SettingsService
  ) {
    super(http, 'public/entidad', Entidad);
  }

  restartItem(): void {
    this.setItem(new Entidad());
  }


  /**
   * Método para obtener la entidad de una persona según su id
   * @param entidadID identificador de entidad
   */
  obtenerEntidad(filtro: any): Observable<any> {
    return this.http.get(this.settings.URL_BASE + 'public/entidad/',filtro);
  }
  
  crearEntidad(data: any): Observable<any> {
    return this.http.post(this.settings.URL_BASE + 'public/entidad/', data);
  }

  actualizarEntidad(data: any, id: any): Observable<any> {
    return this.http.put(this.settings.URL_BASE + 'public/entidad/' + id, data);
  }

  eliminarEntidad(id: any): Observable<any> {
    return this.http.delete(this.settings.URL_BASE + 'public/entidad/' + id);
  }
}
